/**
 * Created by chenzheyu on 2017/7/3.
 */
import XkInformTimeMod from './src/informTimeMod.vue'

XkInformTimeMod.install = function (Vue) {
  Vue.component(XkInformTimeMod.name, XkInformTimeMod)
}

export default XkInformTimeMod



// WEBPACK FOOTER //
// ./src/components/module/informTimeMod/index.js